import { cloneDeep } from 'lodash';
import type { RouteObject } from 'react-router-dom';

/** 可被 joinPrefix 递归拼接 path 的路由树（与 react-router RouteObject 兼容，可有 title 等扩展字段） */
export type JoinPrefixRoute = RouteObject & { children?: JoinPrefixRoute[] };

/**
 * 将同一套路由树按多个前缀各复制一份，并在每条节点上拼接 prefix + path（path 为 `'/'` 的节点不改写）。
 */
export function joinPrefix(routers: JoinPrefixRoute[], prefixArr: string[]): JoinPrefixRoute[] {
  const join = (prefix: string, arr: JoinPrefixRoute[]): JoinPrefixRoute[] => {
    for (const obj of arr) {
      if (obj.children?.length) {
        obj.children = join(prefix, obj.children);
      }
      const p = obj.path;
      if (p && p !== '/') {
        obj.path = prefix + p;
      }
    }
    return arr;
  };
  return prefixArr.flatMap((prefix) => join(prefix, cloneDeep(routers)));
}

/** 将多组叶子路由合并为一维数组（每一项须为数组） */
export function mergeRouters<T>(routers: T[][]): T[] {
  return routers.flat();
}
